export default function userReducer(user, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return {
        ...user,
        exten: action.value ? Number(action.value).toString() : "",
        username: `${action.pbxContext}-${action.value}`,
      };
    case "ringSeconds":
      return { ...user, [action.type]: Number(action.value) };
    case "flexUserPincode":
      return { ...user, [action.type]: action.value === "" ? null : action.value };
    case "countryCallingCode":
      return { ...user, [action.type]: action.value ? Number(action.value.replace("+", "")) : null };
    case "softphone":
      return { ...user, softphone: action.value, sippasswd: action.password, confirmPassword: action.password };
    case "wallpaper":
    case "screensaver":
      return { ...user, [action.type]: action.value === null ? null : { id: action.value } };
    case "codecs":
      return { ...user, [action.type]: action.value, videosupport: action?.videosupport ?? user.videosupport };
    case "resetPassword":
      return { ...user, sippasswd: action.value, confirmPassword: action.value };
    case "yealinkConfig":
    case "fanvilConfig":
      return { ...user, ...action.value };

    case "addPhonebook":
      return { ...user, phonebooks: [...user.phonebooks, action.phonebook] };
    case "removePhonebook":
      return { ...user, phonebooks: user.phonebooks.filter((phonebook) => phonebook.id !== action.phonebook.id) };

    case "addLineKeyTemplateAccount":
      return { ...user, lineKeyTemplateAccounts: [...user.lineKeyTemplateAccounts, action.lineKeyTemplateAccount] };
    case "updateLineKeyTemplateAccount":
      return {
        ...user,
        lineKeyTemplateAccounts: [
          ...user.lineKeyTemplateAccounts.filter((lkta) => lkta.id !== action.lineKeyTemplateAccount.id),
          action.lineKeyTemplateAccount,
        ],
      };
    case "removeLineKeyTemplateAccount":
      return {
        ...user,
        lineKeyTemplateAccounts: user.lineKeyTemplateAccounts.filter(
          (lkta) => lkta.id !== action.lineKeyTemplateAccount.id,
        ),
      };

    case "addDistinctiveRingtone":
      return { ...user, distinctiveRingtones: [...user.distinctiveRingtones, action.distinctiveRingtone] };
    case "removeDistinctiveRingtone":
      return {
        ...user,
        distinctiveRingtones: user.distinctiveRingtones.filter(
          (_distinctiveRingtone) => _distinctiveRingtone.id !== action.distinctiveRingtone.id,
        ),
      };

    default:
      return { ...user, [action.type]: action.value };
  }
}
